import { $t } from '@previo/core'
import { Codebook } from '../Codebook'

export enum CommunicationChannelId {
  ALL = 0,
  EMAIL = 1,
  SMS = 2,
  WHATSAPP = 3,
  OTA = 4,
}

export class CommunicationChannel extends Codebook<CommunicationChannelId> {
  static readonly ALL = new CommunicationChannel(CommunicationChannelId.ALL, () => $t('All'), null)
  static readonly EMAIL = new CommunicationChannel(
    CommunicationChannelId.EMAIL,
    () => $t('Email'),
    'envelope',
  )
  static readonly SMS = new CommunicationChannel(
    CommunicationChannelId.SMS,
    () => $t('SMS'),
    'message-sms',
  )
  static readonly OTA = new CommunicationChannel(
    CommunicationChannelId.OTA,
    () => $t('OTA'),
    'globe',
  )
  static readonly WHATSAPP = new CommunicationChannel(
    CommunicationChannelId.WHATSAPP,
    () => $t('Whatsapp'),
    'brand whatsapp',
  )

  private constructor(
    public readonly id: CommunicationChannelId,
    public readonly name: () => string,
    public readonly icon: string | null,
  ) {
    super(id)
  }
}
